import * as d3 from 'd3'

export const multiFormat = (date: Date): string => {
  if (d3.timeDay(date) < date) return d3.timeFormat('%H:%M')(date)
  if (d3.timeMonth(date) < date) return d3.timeFormat('%m/%d')(date)
  if (d3.timeYear(date) < date) return d3.timeFormat('%m/%d')(date)
  return d3.timeFormat('%Y')(date)
}
